module.exports = __webpack_public_path__ + "img/2.c2484840.png";